import { ChangeDetectionStrategy, Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { round } from '@sama/micro-dash';
import { ToggleButton } from '../../../../cross-team-shared/components/toggle-button-group/toggle-button-group.component';
import { Point3D } from '../../../../team-apis/otterdam/answers/shape-typings';
import { RescaleMethod } from '../cuboid-rescale.service';

export type CuboidRescaleResponse = {
  dimensions: Point3D;
  rescaleMethod: RescaleMethod;
};

export interface CuboidRescaleModalConfig {
  height: number;
  width: number;
  length: number;
}

interface DimensionField {
  label: keyof CuboidRescaleModalConfig;
  dotColor: string;
}

@Component({
  selector: 'h3-cuboid-rescale-modal',
  templateUrl: './cuboid-rescale-modal.component.html',
  styleUrls: ['./cuboid-rescale-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class CuboidRescaleModalComponent {
  protected fields: DimensionField[] = [
    { label: 'length', dotColor: '#1DDA24' },
    { label: 'width', dotColor: '#E13F26' },
    { label: 'height', dotColor: ' #0863F8' },
  ];
  protected rescaleMethod: RescaleMethod = 'rescale_all_frames';
  protected rescaleMethodButtons: Array<ToggleButton<RescaleMethod>> = [
    {
      label: 'Current frame',
      value: 'rescale_current_frame',
      contextualClassWhenActive: 'primary',
    },
    {
      label: 'All frames',
      value: 'rescale_all_frames',
      contextualClassWhenActive: 'primary',
    },
  ];

  constructor(
    @Inject(MAT_DIALOG_DATA) protected data: CuboidRescaleModalConfig,
    private dialogRef: MatDialogRef<CuboidRescaleModalComponent>,
  ) {
    data.height = round(data.height, 2);
    data.width = round(data.width, 2);
    data.length = round(data.length, 2);
  }

  rescaleAndClose() {
    const response: CuboidRescaleResponse = {
      dimensions: [
        // Order of fields does not match the order of dimensions in the Point3D
        this.data.width,
        this.data.length,
        this.data.height,
      ],
      rescaleMethod: this.rescaleMethod,
    };
    this.dialogRef.close(response);
  }
}
